module.exports = __webpack_public_path__ + "assets/img/FinancialMall.c88981d8.png";